import { useCurrentUser } from '@qualio/ui-components';
import { useMutation } from 'react-query';
import { documentApi } from '../../../../../api/document';

type RevertSequentialToDraftParams = {
  documentId: number;
  comment?: string;
};

export const useRevertSequentialToDraft = () => {
  const { companyId } = useCurrentUser();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({ documentId, comment }: RevertSequentialToDraftParams) =>
      documentApi.revertSequentialToDraft(companyId, documentId, comment),
  });

  return { revertSequentialToDraft: mutateAsync, isLoading };
};
